export const categories = [
  {
    name: 'Gol Poshak',
    imgUrl:
      'https://www.dropbox.com/s/uyrxbqdyikl7c8b/poshak_lowres.jpg?raw=1',
    desc: 'Poshak for laddu gopal',
    link: 'poshak',
  },
  {
    name: 'Pagadi',
    imgUrl:
      'https://www.dropbox.com/s/ezzstuazcwq0vpz/pagadi_lowres.jpg?raw=1',
    desc: 'Pagadi for laddu gopal',
    link: 'pagadi',
  },
  {
    name: 'Mukut',
    imgUrl:
      'https://www.dropbox.com/s/b8tnfflbkqjnccu/mukut_lowres.jpg?raw=1',
    desc: 'Mukut for laddu gopal',
    link: 'mukut',
  },
  {
    name: 'Mala',
    imgUrl:
      'https://www.dropbox.com/s/ug167e86i9r6de3/mala_lowres.jpg?raw=1',
    desc: 'Mala for laddu gopal',
    link: 'mala',
  },
  {
    name: 'Durga Poshak',
    imgUrl:
      'https://www.dropbox.com/s/iejijje2ku0oys4/durga_lowres.jpg?raw=1',
    desc: 'Poshak for durga maa',
    link: 'durga',
  },
  {
    name: 'Idols',
    imgUrl:
      'https://www.dropbox.com/s/r24g6z34xjdgou0/idol_lowres.jpg?raw=1',
    desc: 'Idols / Murtis',
    link: 'idols',
  },
  {
    name: 'Jhoola',
    imgUrl:
      'https://www.dropbox.com/s/yfwbwxn7n8gjvyh/jhoola_lowres.jpg?raw=1',
    desc: 'Jhoola for laddu gopal',
    link: 'jhoola',
  },
  {
    name: 'Singhasan',
    imgUrl:
      'https://www.dropbox.com/s/wxscofv5yt3xfbd/singhasan_lowres.jpg?raw=1',
    desc: 'Singhasan for laddu gopal',
    link: 'singhasan',
  },
  {
    name: 'Lehenga Patka',
    imgUrl:
      'https://www.dropbox.com/s/6jrcr0ibfb7ylj3/lp_lowres.jpg?raw=1',
    desc: 'Lehenga Patka for all idols',
    link: 'lp',
  },
]
